<template>
    <div>
        <div class="flex items-center py-5 !px-10">
            <Icon icon="fluent:settings-28-regular" class="!text-5xl" :color="colorAsRoute" />
            <v-card-title :class="`${routeLink}_fortext !text-3xl !font-semibold`">Settings</v-card-title>
        </div>
        <div class="!border-b-[1px] !border-gray-500">
            <v-chip-group :active-class="`${routeLink}_color !text-black`" class="!px-10">
                <v-chip v-for="setting in settings" :key="setting.setting_name" :to="{
                    name: setting.link,
                    params: {
                        type: routeLink,
                        setting: setting.setting_name,
                    },
                }" :class="`${routeLink}_border_color text-white !px-6 !text-sm   !mx-4 mb-7 !py-5 !rounded-full`"
                    outlined>
                    {{ setting.text }}
                </v-chip>
            </v-chip-group>
        </div>
        <div class="h-[calc(100vh-230px)] overflow-auto">
            <component :is="routeSettingLink" class="!max-w-[500px] mx-auto" />
            
        </div>
        
    </div>
</template>
<script>
import { Icon } from '@iconify/vue2';
import ContactUs from '../settings/PremiumContactUs.vue';
import PrivacyPolicy from '../settings/PremiumPrivacyPolicy.vue';
import ProfileSetting from '../settings/PremiumProfileSetting.vue';
import FAQ from '../settings/PremiumFaq.vue';
import SubscriptionDetail from '../settings/subscription_details/SubscriptionDetail.vue';
import PaymentDetails from '../settings/payement_details/PaymentDetails.vue';
import ChangePinCode from '../settings/ChangePinCode.vue';

export default {
    data() {
        return {
            settings: [
                {
                    text: "Profile Update",
                    setting_name: "ProfileSetting",
                    link: "SelectedSetting",
                },
                {
                    text: "Change Lock Screen Pin Code",
                    setting_name: "ChangePinCode",
                    link: "SelectedSetting",
                },
                {
                    text: "Payment Details",
                    setting_name: "PaymentDetails",
                    link: "SelectedSetting",
                },
                {
                    text: "Subscription Details",
                    setting_name: "SubscriptionDetail",
                    link: "SelectedSetting",
                },
                {
                    text: "FAQ",
                    setting_name: "FAQ",
                    link: "SelectedSetting",
                },
                {
                    text: "Privacy Policy",
                    setting_name: "PrivacyPolicy",
                    link: "SelectedSetting",
                },
                {
                    text: "Contact Us",
                    setting_name: "ContactUs",
                    link: "SelectedSetting",
                },

            ],
        }
    },
    computed: {
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
        routeSettingLink() {
            return this.$route.params.setting;
        },
    },
    components: { Icon, ContactUs, PrivacyPolicy, ProfileSetting, FAQ, SubscriptionDetail, PaymentDetails, ChangePinCode }
}
</script>
<style scoped>
.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(180deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(180deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(180deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%) !important;
}

.straight_border_color {
    border-color: #9a7006 !important;
}

.lesbian_border_color {
    border-color: #9e2eec !important;
}

.gay_border_color {
    border-color: #00a1c9 !important;
}
</style>